import { useEffect, useState } from 'react';

import CardHeader from '../../../Components/Card/CardHeader';
import CardBody from '../../../Components/Card/CardBody';
import Button from '../../../Components/Button/Button';
import CardContainer from '../../../Components/Card/CardContainer';
import Input from '../../../Components/Input/Input';
import Select from '../../../Components/Select/Select';
import Homes from '../Homes/Homes';
import { useUlService } from '../../../Services/UlSubjectService';
import { useParams } from 'react-router-dom';
import { useBuildingService } from '../../../Services/Building/BuildingService';

import styles from './building.create.module.css';

export default function BuildingCreate() {
  const {id} = useParams();
  const {getBuilding} = useBuildingService(id);
  const {getUlSubjects} = useUlService();

  const [subjects, setSubjects] = useState([]);
  const [complex, setComplex] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [isCreate, setIsCreate] = useState(true);

  useEffect(() => {
    getUlSubjects().then(res => setSubjects(res))
    getBuilding().then(res => setComplex(res))
    if (id) {
      setIsEdit(true);
      setIsCreate(false)
    }
  }, [])

  return(
    <div className={styles.container}>
      <div className={styles.titles}>
        <h1>Новый ЖК</h1>
        <h3>Жилой комплекс</h3>
        <span >Введите информацию о новом жилом комплексе</span>
      </div>
      <CardContainer>
        <CardHeader
          menu={
            <div className={styles.menu}>
              <Button
                onClick={() => {
                  setIsEdit(!isEdit)
                  setIsCreate(!isCreate);
                }}
                large
                type='default'
                text='Редактировать'
              />
              <Button
                large
                type='error'
                text='Удалить'
              />
            </div>
          }
          label='В работе'
          title="Жилой комплекс"
        />
        <CardBody>
          <div className={styles.wrapper}>
            <Input
              disabled={!isCreate}
              name="complex"
              label="Название ЖК"
              placeholder="Например, ЖК «Династия»"
              onChange={(value) => setComplex({
                ...complex,
                Name: value
              })}
              value={complex?.Name}
            />
            <Input
              disabled={!isCreate}
              name="address"
              label="Адрес"
              placeholder="Например, Почтовая ул., д. 9"
              onChange={(value) => setComplex({
                ...complex,
                Address: {
                  Note: value
                }
              })}
              value={complex?.Address?.Note}
            />
          </div>
          <div className={styles.wrapper}>
            <Select
              disabled={!isCreate}
              label="Выберите юр. лицо застройщика-заявителя"
              placeholder="Выберите застройщика"
              onChange={(value) => setComplex({
                ...complex,
                UlSubject: {
                  code: value,
                }
              })}
              value={complex?.UlSubject?.code}
            >
              {subjects?.map((item) => {
                return (
                  <option value={item.Id}>{item.Name}</option>
                  )
              })}
            </Select>
            <Select
              disabled={!isCreate}
              label="Количество домов в ЖК"
              placeholder="Выберите из списка"
              onChange={(value) => setComplex({
                ...complex,
                Id: value
              })}
              value={complex?.Id}
            >
              { [...Array(10)].map((item, index) => {
                return (
                  <option value={index + 1}>{`${index + 1}`}</option>
                )
              })
              }
            </Select>
          </div>
        </CardBody>
        <div className={styles.footer}>
          {!isEdit &&
            <div className={styles.buttons}>
              <Button type='default' text='Отменить'/>
              <Button
                onClick={() => {
                  setIsEdit(!isEdit)
                  setIsCreate(!isCreate);
                }}
                text='Сохранить'/>
            </div>
          }
        </div>
      </CardContainer>
      {!isCreate &&
        <div className={styles.corpuses}>
          <div className={styles.titles}>
            <h3>Дома в жилом комплексе</h3>
            <span >Введите информацию о жилых домах</span>
          </div>
          {complex?.Id && Array.from({ length: (complex.Id).toString() }).map((_, home) => (
            <Homes home={home + 1} complex={complex && complex}/>
          ))}
        </div>
      }
    </div>
  );
}
